import cssModule from "@vercel/turbopack-next/internal/font/google/cssmodule.module.css?{%22path%22:%22fonts.ts%22,%22import%22:%22Playfair_Display%22,%22arguments%22:[{%22subsets%22:[%22latin%22],%22weight%22:%22400%22,%22display%22:%22swap%22,%22preload%22:false}],%22variableName%22:%22playfairDisplay%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'Playfair Display', 'Playfair Display Fallback'",
        fontWeight: 400,
fontStyle: "normal",

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
